import { render, staticRenderFns } from "./Bcp.vue?vue&type=template&id=45b78dbd&scoped=true&"
import script from "./Bcp.vue?vue&type=script&lang=ts&"
export * from "./Bcp.vue?vue&type=script&lang=ts&"
import style0 from "./Bcp.vue?vue&type=style&index=0&id=45b78dbd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b78dbd",
  null
  
)

export default component.exports